import type { INamekErrorRaw } from "@/models";

/**
 * Genera el mensaje de Centros Verdes a partir del error de Namek (409)
 * - 1 centro: "Centro Verde {nombre}"
 * - N centros: "{N} centros verdes"
 */
export function getGreenCentersMessage(errorData?: INamekErrorRaw): string | undefined {
  const centersParams = errorData?.Details?.find((d) => d.Field === "GreenCenters")?.Params ?? [];

  return centersParams.length === 1
    ? `Centro Verde ${centersParams[0]}`
    : `${centersParams.length} centros verdes`;
}
